import { useNavigate } from "@remix-run/react";
import type { PaginatedResponse } from "../kernel/pagination/paginatedResponse";
import PaginationControls from "./PaginationControls";

type LinkPaginationControlsProps = {
  result: PaginatedResponse<unknown>;
};

export default function LinkPaginationControls({
  result,
}: LinkPaginationControlsProps) {
  const navigate = useNavigate();
  return (
    <PaginationControls
      result={result}
      onNext={() =>
        result.nextPagePath &&
        navigate(result.nextPagePath, { preventScrollReset: true })
      }
      onPrevious={() =>
        result.previousPagePath &&
        navigate(result.previousPagePath, { preventScrollReset: true })
      }
    />
  );
}
